import { render, staticRenderFns } from "./confirm-delete-list-modal.vue?vue&type=template&id=c0bafcfc"
import script from "./confirm-delete-list-modal.vue?vue&type=script&lang=ts"
export * from "./confirm-delete-list-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports